import { Anchor, Stack, Text, Title } from '@mantine/core';
import { createFileRoute, Link } from '@tanstack/react-router';

import { PageLayout } from '@/components/PageLayout';

export const Route = createFileRoute('/about')({
  component: About,
});

function About() {
  return (
    <PageLayout>
      <Stack align="center" gap="lg" maw={600}>
        <Title order={1} c="white">
          About Handscape
        </Title>

        <Stack gap="md" w="100%">
          <div>
            <Title order={3} size="h5" c="white" mb="xs">
              3D Poker Charts
            </Title>
            <Text c="dimmed" size="sm">
              Traditional 2D charts are excellent for studying, printing, and quick reference. These 3D visualizations
              offer a complementary way to view the same data, making it easier to appreciate the contours and patterns
              in hand ranges and strategies.
            </Text>
          </div>

          <div>
            <Title order={3} size="h5" c="white" mb="xs">
              For Viewing, Not Solving
            </Title>
            <Text c="dimmed" size="sm" mb="sm">
              Handscape is a visualization tool for exploring poker concepts, not a GTO solver or strategy engine. The
              example charts are based on well-known reference materials and simplified models.
            </Text>
            <Text c="dimmed" size="sm">
              If you run your own solver analysis, you can visualize the results using the{' '}
              <Anchor component={Link} to="/custom-chart" c="blue.4">
                Custom Chart
              </Anchor>{' '}
              editor. Just paste in your data as JSON and share via URL.
            </Text>
          </div>

          <div>
            <Title order={3} size="h5" c="white" mb="xs">
              Why Handscape?
            </Title>
            <Text c="dimmed" size="sm">
              Handscape is a play on "landscape". When studying flat 2D charts, I was struggling to appreciate subtle
              differences in probabilities. Inspired by topographic and relief maps, I wanted to see the overall
              "terrain" of hand values and ranges. That idea became this app.
            </Text>
          </div>

          <div>
            <Title order={3} size="h5" c="white" mb="xs">
              Contact
            </Title>
            <Text c="dimmed" size="sm">
              Questions, suggestions, or found an inaccuracy?{' '}
              <Anchor href="mailto:hello@tone.dev" c="blue.4">
                hello@tone.dev
              </Anchor>
            </Text>
          </div>
        </Stack>
      </Stack>
    </PageLayout>
  );
}
